import React, { useEffect, useState } from "react";
import { Button, Dropdown, Image, Offcanvas, Stack } from "react-bootstrap";
import { IoIosArrowDown } from "react-icons/io";
import { RxHamburgerMenu } from "react-icons/rx";
import { useLocation, useNavigate } from "react-router-dom";
import "./Navbar.css";
import { map } from "lodash";
import { MdOutlineLocalPhone, MdOutlineMail } from "react-icons/md";
import { handleContactRedirect } from "../handleContactRedirect";

export const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation()

  const [show, setShow] = useState(false);
  const [toggleChild, setToggleChild] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const menuItem = [
    {
      title: "Home",
      href: "/",
    },
    {
      title: "About Us",
      href: "/about-us",
    },
    {
      title: "Destinations",
      children: [
        { title: "India", href: "/destination/india" },
        { title: "Kenya", href: "/destination/kenya" },
        { title: "South Africa", href: "/destination/south-africa" },
        { title: "Tanzania", href: "/destination/tanzania" },
        { title: "UAE", href: "/destination/uae" },
        { title: "Uganda", href: "/destination/uganda" },
        { title: "Zambia", href: "/destination/zambia" },
        { title: "Zimbabwe", href: "/destination/zimbabwe" },
        { title: "Qatar", href: "/destination/qatar" },
        // { title: "Rwanda", href: "/destination/rwanda" },
        { title: "Malaysia", href: "/destination/malaysia" },
        // { title: "Kazakhstan", href: "/destination/kazakhstan" },
        { title: "Singapore", href: "/destination/singapore" },
      ],
    },
    {
      title: "B2B Agents",
      href: "/b2b-agents",
    },
    {
      title: "Experiences",
      href: "/experiences",
    },
    {
      title: "Medical Tourism",
      href: "/medical"
    }
    // {
    //   title: "Corporate",
    //   href: "/corporate",
    // },
    // {
    //   title: "Blog",
    //   href: "/blog",
    // },
  ];

  const [scrolled, setScrolled] = useState(false);
  const [scrolledMobile, setScrolledMobile] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 90);
      setScrolledMobile(window.scrollY > 60);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Stack direction="horizontal" className={`navbar-new ${scrolled ? "navbar-scrolled" : ""}`} >
        <div className=" d-flex justify-content-between navbar2">
          <div className=" d-flex justify-content-center">
            <Image
              className="header-logo"
              alt="Blueberry DMC home"
              // src={scrolled ? "/assets/DMC-01.png" : "/assets/DMC-white-01.png"}
              src={scrolled ? "/assets/dmc-logo.svg" : "/assets/dmc-logo.svg"}
              onClick={() => navigate("/")}
            />

          </div>
          <div className=" h-100" >
            <Stack
              direction="horizontal"
              gap={3}
              className="d-flex h-50 pt-0 justify-content-between align-items-center nav-section"
            >
              <Stack direction="horizontal" className="menu-item-div">
                {map(menuItem, (item) =>
                  item.children ? (
                    <Dropdown key={item.title}>
                      <Dropdown.Toggle
                        as="span"
                        className="custom-dropdown-toggle"
                      >
                        <div
                          className={`menu-item ${location.pathname.includes("destination")
                            ? "menu-item-selected"
                            : ""
                            }`}
                        >
                          {item.title}&nbsp;
                          <IoIosArrowDown />
                        </div>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {map(item.children, (child) => (
                          <Dropdown.Item
                            as="button"
                            className={`${location.pathname.includes(child.href) ? "menu-item-selected" : ""}`}
                            style={location.pathname.includes(child.href) ? { color: "#134685", fontWeight: "600" } : {}}
                            onClick={() => navigate(child.href)}>
                            {child.title}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    <div
                      key={item.href}
                      className={`menu-item ${location.pathname === item.href
                        ? "menu-item-selected"
                        : ""
                        }`}
                      onClick={() => navigate(item.href)}
                    >
                      {item.title}
                    </div>
                  )
                )}
              </Stack>

            </Stack>
          </div>
          <div className=" d-flex justify-content-center">
            <Stack gap={3} direction="horizontal">
              {/* <FaFacebookF />
                <FaInstagram />
                <FaXTwitter /> */}
              <Button
                className=" fw-semibold"
                variant="light"
                style={{ backgroundColor: "#134685", color: "white", padding: "12px 25px", fontSize: "14px" }}
                size="sm"
                onClick={() => navigate("/contact-us")}
              >
                Partner with us
              </Button>
            </Stack>
          </div>
        </div>
      </Stack >

      <div className={`navbar-mobile ${scrolledMobile ? "navbar-mobile-scrolled" : ""}`}>
        <Image
          className="navbar-image"
          alt="Blueberry DMC home"
          src={scrolled ? "/assets/dmc-logo.svg" : "/assets/dmc-logo.svg"}
          onClick={() => navigate("/")}
        />
        <div className="navbar-container">
          {/* <div
            className="bg-white text-black px-3 py-1"
            style={{ borderRadius: 30 }}
          >
            <text>IND</text>
            &nbsp;&nbsp;
            <IoIosArrowDown style={{ marginTop: "-2px" }} fontSize={20} />
          </div>
          <FiSearch fontSize={24} /> */}

          <RxHamburgerMenu fontSize={24} onClick={handleShow} />

          <Offcanvas show={show} placement="end" onHide={handleClose}>
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>
                <Image
                  className="navbar-image"
                  alt="Blueberry DMC home"
                  src={"/assets/dmc-logo.svg"}
                  onClick={() => navigate("/")}
                />
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="navbar-drawer-body">
              {map(menuItem, (item) =>
                item.children ? (
                  <div key={item.title} className="navbar-drawer-body">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        cursor: "pointer",
                      }}
                      onClick={() => setToggleChild(!toggleChild)}
                    >
                      <p className="navbar-item-title">{item.title}</p>
                      <IoIosArrowDown
                        style={{ marginTop: "-2px" }}
                        fontSize={20}
                      />
                    </div>
                    {toggleChild &&
                      map(item.children, (child) => (
                        <p
                          key={child.href}
                          className="navbar-child-title"
                          onClick={() => navigate(child.href)}
                        >
                          {child.title}
                        </p>
                      ))}
                  </div>
                ) : (
                  <p
                    key={item.href}
                    className="navbar-item-title"
                    onClick={() => navigate(item.href)}
                  >
                    {item.title}
                  </p>
                )
              )}
              <Stack gap={3} direction="horizontal">
                {/* <FaFacebookF />
                <FaInstagram />
                <FaXTwitter /> */}
                <Button
                  className=" fw-semibold"
                  style={{ width: "70%", backgroundColor: "#134685", color: "white", padding: "12px 25px" }}
                  variant="success"
                  size="sm"
                  onClick={() => navigate("/contact-us")}
                >
                  Partner with us
                </Button>
              </Stack>
              {/* Clickable phone number */}
              {/* <div>
                <a
                  href="tel:+971559886749"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MdOutlineLocalPhone fontSize={18} />
                  &nbsp;+971559886749
                </a>

              </div> */}

              <div>
                <a
                  href="tel:+971559886749"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MdOutlineLocalPhone fontSize={18} />
                  &nbsp;+971559886749
                </a>

              </div>

              {/* Clickable email */}
              <div>
                <a
                  href="mailto:holidays@blueberrydmc.com"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <MdOutlineMail fontSize={18} />
                  &nbsp;holidays@blueberrydmc.com
                </a>
              </div>
              {/* <Button className="navbar-button-login">LOG IN/SIGN UP</Button> */}
            </Offcanvas.Body>
          </Offcanvas>
        </div>
      </div>
    </>
  );
};